import { Component, Injector, Input } from '@angular/core';
import { SlideWindowAbstract, UNPLACEHOLDER } from '@dm/core';
import { AntivirusStrService } from '../../../antivirus-str.service';

@Component({
    selector: 'app-file-path-detail',
    templateUrl: './file-path-detail.component.html',
    styleUrls: ['./file-path-detail.component.scss'],
})
export class FilePathDetailComponent extends SlideWindowAbstract {
    @Input() filePath: string = UNPLACEHOLDER;

    i18n = this.str.i18n;
    windowVisible = true;

    constructor(
        injector: Injector,
        public str: AntivirusStrService,
    ) {
        super(injector);
    }
}
